import { render, staticRenderFns } from "./AcademicPrograms.vue?vue&type=template&id=41d30bf6&scoped=true"
import script from "./AcademicPrograms.vue?vue&type=script&lang=js"
export * from "./AcademicPrograms.vue?vue&type=script&lang=js"
import style0 from "./AcademicPrograms.vue?vue&type=style&index=0&id=41d30bf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d30bf6",
  null
  
)

export default component.exports